<script setup lang="ts">
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

import KBtn from '@/components/btns/KBtn.vue';
import NoDataListItem from '@/components/items/NoDataListItem.vue';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';

export interface Item {
  id: number;
  name: string;
  route: string;
  params: Record<string, unknown>;
}

export interface Props {
  delete?: (itemId: number) => Promise<unknown>;
  items?: Item[];
  isLoading?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  delete: undefined,
  items: () => [],
  isLoading: false,
});

const loadings: Record<string, boolean> = reactive({});

function handleDeleteClick(event: Event, itemId: number): void {
  if (!props.delete) return;
  loadings[itemId] = true;
  void props.delete(itemId).finally(() => {
    loadings[itemId] = false;
  });
}

const route = useRoute();
</script>

<template>
  <menu :class="$style.savedFiltersMenuList" data-testid="savedFiltersMenuList">
    <template v-if="props.isLoading">
      <li :class="$style.li">
        <SimpleLoader :class="$style.simpleLoader" />
      </li>
    </template>
    <template v-else-if="!props.items.length">
      <NoDataListItem class="!p-0" :class="$style.li">
        <div :class="$style.text">Filters not found</div>
      </NoDataListItem>
    </template>
    <template v-else>
      <li v-for="item in props.items" :key="item.id" :class="$style.li">
        <div :class="$style.text">
          <router-link
            :to="{
              name: item.route,
              query: { ...item.params, dates: route.query.dates },
            }"
          >
            {{ item.name }}
          </router-link>
        </div>
        <div :class="$style.action">
          <KBtn
            :disabled="!props.delete"
            size="xs"
            priority="info"
            variant="text"
            :class="$style.deleteFilterIconBtn"
            icon="mdi-delete-outline"
            title="Delete filter"
            :loading="loadings[item.id]"
            @click="handleDeleteClick($event, item.id)"
          />
        </div>
      </li>
    </template>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.savedFiltersMenuList {
  line-height: 1.4;
  margin: 0;
  padding: 0;
  list-style: none;
}
  .li {
    display: flex;
    justify-content: space-between;
  }
    .simpleLoader {
      min-height: 32.39px;
    }
    .text {
      align-self: center;
      padding: 5px 4px 5px 0;
    }
    .action {
      width: 32px;
    }
      .deleteFilterIconBtn {
      }
</style>
